import {Fancybox} from "@fancyapps/ui";

function enableFancybox(target = "[data-fancybox]", params = {}) {
	if (App.debug) {
		console.info('init: fancybox');
	}

	Fancybox.bind(target, Object.assign(params, {
		Image: {
			zoom: false,
		},
		Images: {
			Panzoom: {
				maxScale: 2,
			},
		},
		Toolbar: {
			display: {
				left: ["infobar"],
				middle: ["zoomIn", "zoomOut"],
				right: ["close"],
			},
		},
	}));
}

export default enableFancybox;
